
import React, { useEffect, useState } from 'react';
import styles from './CycleOverViewList.module.css';
import { Cycle, getcycleList } from './CycleOverviewListHelper';
import active from '../../assets/SVG/active.svg';
import inactive from '../../assets/SVG/Inactive.svg';
import { Button, Typography, Dialog, DialogContent, TextField, Grid } from '@mui/material';
import CreateNewCycle from './CreateNewCycle';
import TerminateCycleConfirmation from './TerminateCycleConfirmation';
import CycleDetails from './CycleDetails';
import { useLoader } from '../loaderProvider/loader';
import { useAlert } from '../alertProvider';
import UpdateDisabledSharpIcon from '@mui/icons-material/UpdateDisabledSharp';
import { usePatientContext } from '../SubPatinetProvider';
import { Avatar, Tooltip } from '@mui/material'; 
import AvatarGroup from '@mui/material/AvatarGroup';
import { useLocation, useParams } from 'react-router-dom';
import { useCycle } from '../cycleContext/CycleContext';
import { convertUnderscoreToTitle } from '../../utils/commonUtils';
import { patientDetailsObservable } from '../../services/sharedService';



const CycleOverviewList = () => {

  
  const [isCreateCycleDialogOpen, setCreateCycleDialogOpen] = React.useState(false);
  const [isTerminateCycleDialogOpen, setTerminateCycleDialogOpen] = React.useState(false);
  const [isCycleDetailsVisible, setCycleDetailsVisible] = useState(false);
  const [selectedIdTerminate, setSelectedIdTerminate] = useState<string | null>(null);
  const { showLoader, hideLoader } = useLoader();
  const { addAlert } = useAlert();
  const { patientId } = usePatientContext();
  const [cyclesData, setCyclesData] = useState<Cycle[]>([]); 
  const [filteredCycles, setFilteredCycles] = useState<Cycle[]>([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedCycle, setSelectedCycle] = useState<string | null>(null);
  const location = useLocation();
  const { setCycleId } = useCycle();
  const { id } = useParams();
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const [patientDetails, setpatientDetails] = useState<any >(null);
  
    
    
  
  useEffect(() => {
    const subscription = patientDetailsObservable.subscribe((value) => {
      setpatientDetails(value);
    });
  
    return () => subscription.unsubscribe();
  }, []);

  const handleOpenDialog = () => {
    setCreateCycleDialogOpen(true);
  };


  useEffect(()=>{
    if (location.state?.cycleId) {
      setCycleDetailsVisible(true);
      setSelectedCycle(location.state.cycleId);
    } else if (location.search) {
      const queryParams = new URLSearchParams(location.search);
      const cycleIdFromQuery = queryParams.get('cycleId');
      if (cycleIdFromQuery) {
        setCycleDetailsVisible(true);
        setSelectedCycle(cycleIdFromQuery);
      }
    }
    
  },[location]);
  const handleCloseDialog = () => {
    setCreateCycleDialogOpen(false);
  };

  const handleTerminateCloseDialog = () => {
    setTerminateCycleDialogOpen(false);
  };

   
  const handleRowClick = (cycle: Cycle) => {
    setCycleDetailsVisible(true);
    setSelectedCycle(cycle.id);
    if (!['SPERM_DONOR', 'OOCYTE_DONOR', 'SURROGATE'].includes(patientDetails?.type)) {
      setCycleId(Number(cycle.id));
    }
  };
  
  const handleCycleListClick = () => {
    setCycleDetailsVisible(false);
  };

  useEffect(() => {

    return () => {
      setCycleId(null); 
    };
  }, [setCycleId]);

  useEffect(() => {

    showLoader();

    const getPatientId =
  ['SPERM_DONOR', 'OOCYTE_DONOR', 'SURROGATE'].includes(patientDetails?.type)
    ? patientId
    : id;

    
    getcycleList(String(getPatientId))
      .then((data: Cycle[]) => { 
        setTimeout(() => {
          setCyclesData(data);  
          setFilteredCycles(data); 
          hideLoader();
        }, 200);
      })
      .catch((error) => {
        hideLoader();
        if (error?.response?.data?.errors && Array.isArray(error.response.data.errors)) {
          const errorMessage = error.response.data.errors.map((err: { detail: string }) => err.detail).join(', ');
          if (error.response.status !== 404) {
            addAlert(errorMessage, 'error');
          }
          setCyclesData([]); 
        } else {
          // eslint-disable-next-line no-console
          console.error('Error fetching cycle data:', error);
          addAlert('Error fetching cycle data', 'error');
        }
      });
  }, [showLoader, hideLoader, addAlert, id, isCreateCycleDialogOpen, isTerminateCycleDialogOpen, patientDetails, patientId]);


  useEffect(() => {
    if (searchTerm.trim() === '') {
      setFilteredCycles(cyclesData);  
    } else {
      const filtered = cyclesData.filter((cycle) =>
        (cycle.cycle_number && cycle.cycle_number.toLowerCase().includes(searchTerm.toLowerCase())) ||
        (cycle.procedure?.procedures&& cycle.procedure?.procedures.toLowerCase().includes(searchTerm.toLowerCase()))
      );
      setFilteredCycles(filtered);  
    }
  }, [searchTerm, cyclesData]);


  const handleSearchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value;
    setSearchTerm(value);
    if (value.trim() === '') {
      setFilteredCycles(cyclesData);  
    }
  };

  
  return (
    <div style={{ padding: '1rem' }}>
      {isCycleDetailsVisible && selectedCycle !== null ? (
        <CycleDetails handleCycleListClick={handleCycleListClick} cycle={selectedCycle}/>
      ) : (
        <>


          <Grid container spacing={2}>
            <Grid item xs={12} sm={4} md={6} xl={6}>
              <div>
                <Typography variant="h6" className={styles.CycleList}>
        Cycle List
                </Typography>
              </div>
            </Grid>
            <Grid item xs={12} sm={6} md={6} xl={6}>
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'flex-end',
                  alignItems: 'center',
                }}
              >
                <TextField
                  id="outlined-basic"
                  label="Search by Cycle Number & Cycle Name"
                  variant="outlined"
                  value={searchTerm}
                  onChange={handleSearchChange}
                  style={{
                    width: '500px',
                    marginRight: '16px',
                  }}
                />
                <Button
                  variant="contained"
                  color="primary"
                  className={styles.AddNewCycle}
                  onClick={handleOpenDialog}
                  disabled={cyclesData.some((cycle) => cycle.status === 'ACTIVE')}
                >
                  <span className={styles.AddNewCycleText}>Create a New Cycle</span>
                </Button>
              </div>
            </Grid>
          </Grid>

          <div className="mt-4">
            <div style={{ overflowX: 'auto', width: '100%' }}>
              <table className={styles.custom_table}>
                <thead className={styles.custom_table_head}>
                  <tr>
                    <th className={styles.custom_table_cell} style={{width:'4.5rem'}}></th>
                    <th className={styles.custom_table_cell}>Cycle Status</th>
                    <th className={styles.custom_table_cell}>#Cycle</th>
                    <th className={styles.custom_table_cell}>LMP</th>
                    <th className={styles.custom_table_cell}>Cycle Name</th>
                    <th className={styles.custom_table_cell}>Medication  Protocol</th>
                    <th className={styles.custom_table_cell}>Indication</th>
                    <th className={styles.custom_table_cell}>Oocyte Source </th>
                    <th className={styles.custom_table_cell}>Sperm Source</th>
                    <th className={styles.custom_table_cell}>#Follicules</th>
                    <th className={styles.custom_table_cell}>OPU</th>
                    <th className={styles.custom_table_cell}>#Oocyte</th>
                    <th className={styles.custom_table_cell}>#Fertilized</th>
                    <th className={styles.custom_table_cell}>#Cleaved</th>
                    <th className={styles.custom_table_cell}>#Cryo</th>
                    <th className={styles.custom_table_cell}>Embryo Transfer</th>
                    <th className={styles.custom_table_cell}>BHCG/UPT</th>
                    <th className={styles.custom_table_cell}>Pregnancy Confirmation</th>
                    <th className={styles.custom_table_cell}>Remaining Embryo’s</th>
                    <th className={styles.custom_table_cell}>Cancel Remark</th>
                  </tr>
                </thead>
                <tbody className={styles.custom_table_body}>
                  {filteredCycles.length === 0 ? (
                    <tr>
                      <td colSpan={19} className={styles.noDataFound}>
            No data found
                      </td>
                    </tr>
                  ) : (
                    filteredCycles.map((cycle) => (
                      <tr
                        key={cycle.id}
                        className={styles.custom_table_row}
                        onClick={() => handleRowClick(cycle)}
                      >
                        <td className={`${styles.custom_table_cell} ${styles.tb_main_text}`} style={{ width: '4.5rem' }}>
                          {cycle.status === 'ACTIVE' && (
                            <Tooltip title="Terminate Cycle" arrow>
                              <UpdateDisabledSharpIcon
                                onClick={(event: { stopPropagation: () => void }) => {
                                  event.stopPropagation();
                                  setSelectedIdTerminate(cycle.id);
                                  setTerminateCycleDialogOpen(true);
                                }}
                                style={{ cursor: 'pointer' }} // Makes it clear that it's clickable
                              />
                            </Tooltip>
                          )}
                        </td>

                        <td className={`${styles.custom_table_cell} ${styles.tb_main_text}`}>
                          <img
                            src={cycle.status === 'ACTIVE' ? active : inactive}
                            alt={cycle.status}
                            className={styles.status_icon}
                          />
                        </td>
                        <td className={`${styles.custom_table_cell} ${styles.cycle_code_cell}`}>
                          {cycle.cycle_number || '-'}
                        </td>
                        <td className={`${styles.custom_table_cell} ${styles.tb_main_text}`}>
                          {cycle.lmp_date || '-'}
                        </td>
                        <td className={`${styles.custom_table_cell} ${styles.tb_main_text}`}>
                          {cycle.procedure?.procedures || '-'}
                        </td>
                        <td className={`${styles.custom_table_cell} ${styles.tb_main_text}`}>
                          {cycle?.medication_protocol || '-'}
                        </td>
                        <td className={`${styles.custom_table_cell} ${styles.tb_main_text}`}>
                          {convertUnderscoreToTitle(cycle.procedure?.indication) || '-'}
                        </td>

                        <td className={`${styles.custom_table_cell} ${styles.tb_main_text}`}>
                          {cycle.procedure?.donor_info?.oocyte_source?.length ? (
                            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '10px' }}>
                              <AvatarGroup max={8}>
                                {cycle.procedure?.donor_info?.oocyte_source?.map((source: { first_name: string; last_name: string; medical_record_no: string; photo: string | null }, index: number | null | undefined) => (
                                  <Tooltip key={index} title={`${source.first_name || ''} ${source.last_name || 'Self'} , Medical Record: ${source.medical_record_no || '-'}`} arrow>
                                    <Avatar 
                                      alt={`${source.first_name} ${source.last_name}`} 
                                      src={source.photo || undefined} 
                                    >
                                      {!source.photo && 
                `${source.first_name?.charAt(0) || ''}${source.last_name?.charAt(0) || ''}`}
                                    </Avatar>
                                  </Tooltip>
                                ))}
                              </AvatarGroup>
                            </div>
                          ) : null}
                        </td>
                        <td className={`${styles.custom_table_cell} ${styles.tb_main_text}`}>
                          {cycle.procedure?.donor_info?.sperm_source?.length ? (
                            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '10px' }}>
                              <AvatarGroup max={8}>
                                {cycle.procedure?.donor_info?.sperm_source?.map((source: { first_name: string; last_name: string; medical_record_no: string; photo: string | null }, index: number | null | undefined) => (
                                  <Tooltip key={index} title={`${source.first_name || ''} ${source.last_name || 'Self'} , Medical Record: ${source.medical_record_no || '-'}`} arrow>
                                    <Avatar 
                                      alt={`${source.first_name} ${source.last_name}`} 
                                      src={source.photo || undefined}
                                    >
                                      {!source.photo && 
                `${source.first_name?.charAt(0) || ''}${source.last_name?.charAt(0) || ''}`}
                                    </Avatar>
                                  </Tooltip>
                                ))}
                              </AvatarGroup>
                            </div>
                          ) : null}
                        </td>

                        <td className={`${styles.custom_table_cell} ${styles.tb_main_text}`}>
                          {
                            (cycle.optimum_follicles?.left_follicles ?? 0) + (cycle.optimum_follicles?.right_follicles ?? 0) || '-'
                          }
                        </td>
                        <td className={`${styles.custom_table_cell} ${styles.tb_main_text}`}>
                          {cycle.opu_status ? (
                            <div className={styles.statusBadgeSuccess}>
      Completed
                            </div>
                          ) : (
                            <div className={styles.statusBadgePending}>
      Pending
                            </div>
                          )}
                        </td>
                        <td className={`${styles.custom_table_cell} ${styles.tb_main_text}`}>
                          {cycle.oocyte_count || '-'}
                        </td>


                        <td className={`${styles.custom_table_cell} ${styles.tb_main_text}`}>
                          {cycle.fertilized_count || '-'}
                        </td>
                        <td className={`${styles.custom_table_cell} ${styles.tb_main_text}`}>
                          {cycle.cleaved_count || '-'}
                        </td>
                        <td className={`${styles.custom_table_cell} ${styles.tb_main_text}`}>
                          {cycle.cryopreserved_count || '-'}
                        </td>
                        <td className={`${styles.custom_table_cell} ${styles.tb_main_text}`}>
                          <div style={{ display: 'flex', alignItems: 'center' }}>
                            <div className={`${styles.squareBox} ${styles.greenBox}`}></div>
                            <span style={{ marginLeft: '0.5rem' }}>
                              {cycle.fresh_transfer_count !== null && cycle.fresh_transfer_count !== undefined
                                ? cycle.fresh_transfer_count
                                : '-'}
                            </span>
                            <div
                              className={`${styles.squareBox} ${styles.secondBox}`}
                              style={{ marginLeft: '1rem' }}
                            ></div>
                            <span style={{ marginLeft: '0.5rem' }}>
                              {cycle.frozen_transfer_count !== null && cycle.frozen_transfer_count !== undefined
                                ? cycle.frozen_transfer_count
                                : '-'}
                            </span>
                          </div>
                        </td>
                        <td className={`${styles.custom_table_cell} ${styles.tb_main_text}`}>
                          {cycle.bhcg_upt || '-'}
                        </td>
                        <td className={`${styles.custom_table_cell} ${styles.tb_main_text}`}>
                          {cycle.pregnancy_confirmation || '-'}
                        </td>
                        <td className={`${styles.custom_table_cell} ${styles.tb_main_text}`}>
                          {cycle.remaining_embryos || '-'}
                        </td>
                        <td className={`${styles.custom_table_cell} ${styles.tb_main_text}`}>
                          {convertUnderscoreToTitle(cycle.cancel_reason) || '-'}
                        </td>

                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>

  
            <div className="mt-4">
              <div className={styles.boxWrapper}>
                <div className={`${styles.box} ${styles.box1} ${styles.custom_table_cell}`}></div>
                <span className={styles.customtext}>Fresh Embryo</span>
                <div className={`${styles.box} ${styles.box2} ${styles.custom_table_cell}`}></div>
                <span className={styles.customtext}>Frozen Embryo</span>
              </div>
            </div>
          </div>


        </>
      )}
 
  


      {/* Dialog to show CreateNewCycle component */}
      <Dialog
        open={isCreateCycleDialogOpen}
        onClose={handleCloseDialog}
        PaperProps={{
          style: {
            borderRadius: '20px',
            width: '60rem',
            maxWidth: '70vw',
            padding: '1rem',
          },
        }}
        aria-labelledby="create-cycle-dialog-title"
      >
        <DialogContent
          className="p-0"
          style={{
            paddingLeft: '2rem',
            paddingRight: '2rem',
          }}
        >
          <CreateNewCycle onClose={handleCloseDialog} />
        </DialogContent>
      </Dialog>

      {/* Dialog to show Terminate Cycle component */}
      <Dialog
        open={isTerminateCycleDialogOpen}
        onClose={handleTerminateCloseDialog}
        PaperProps={{
          style: {
            borderRadius: '20px',
            width: '60rem',
            maxWidth: '70vw',
            padding: '1rem',
          },
        }}
        aria-labelledby="terminate-cycle-dialog-title"
      >
        <DialogContent
          className="p-0"
          style={{
            paddingLeft: '2rem',
            paddingRight: '2rem',
          }}
        >
          <TerminateCycleConfirmation onClose={handleTerminateCloseDialog} cycleId={selectedIdTerminate} />
        </DialogContent>
      </Dialog>
    </div>
  );
};

export default CycleOverviewList;
